module.exports = __webpack_public_path__ + "img/coupon-logo@3x.21a4ccfa.png";